var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOalpha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.9351C3 8.19459 3.63736 5.27567 4.91209 3.17838C6.20879 1.05946 8.42857 0 11.5714 0C14.7143 0 16.9231 1.05946 18.1978 3.17838C19.4945 5.27567 20.1429 8.19459 20.1429 11.9351C20.1429 15.7189 19.4945 18.6811 18.1978 20.8216C16.9231 22.9405 14.7143 24 11.5714 24C8.42857 24 6.20879 22.9405 4.91209 20.8216C3.63736 18.6811 3 15.7189 3 11.9351ZM16.4505 11.9351C16.4505 10.1838 16.3297 8.7027 16.0879 7.49189C15.8681 6.28108 15.4066 5.2973 14.7033 4.54054C14 3.76216 12.956 3.37297 11.5714 3.37297C10.1868 3.37297 9.14286 3.76216 8.43956 4.54054C7.73626 5.2973 7.26374 6.28108 7.02198 7.49189C6.8022 8.7027 6.69231 10.1838 6.69231 11.9351C6.69231 13.7514 6.8022 15.2757 7.02198 16.5081C7.24176 17.7405 7.7033 18.7351 8.40659 19.4919C9.13187 20.2486 10.1868 20.627 11.5714 20.627C12.956 20.627 14 20.2486 14.7033 19.4919C15.4286 18.7351 15.9011 17.7405 16.1209 16.5081C16.3407 15.2757 16.4505 13.7514 16.4505 11.9351Z",
    fill: "#4D3ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOalpha);
export default __webpack_public_path__ + "static/media/oalpha.f2d62ba0fdff496ee3ee4934d35935c2.svg";
export { ForwardRef as ReactComponent };